// @flow
import type { ComparedMetric, ComparedMetricByTime } from './DashboardData';

export function convertComparedMetricByTimeToGraphData(data: ComparedMetricByTime) {
  const convertedDataArray = [];
  Object.keys(data).sort().forEach((key) => {
    const x = parseInt(key.split(':')[0], 10);
    const value = {
      hour: key,
      x: x,
      current: data[key].current,
      compared: data[key].compared,
    };
    convertedDataArray.push(value);
  });

  return convertedDataArray;
}

export type ComparedMetricForHour = ComparedMetric & {
  hour?: string;
  x: number;
}

export function addIntersects(data: Array<ComparedMetricForHour>) {
  // The algorithm works when dx is always 1
  const dataWithIntersects = data.length > 0 ? [data[0]] : [];

  for (let i = 0; i < data.length - 1; ++i) {
    const current = data[i];
    const next = data[i + 1];

    const dy1 = next.current - current.current;
    const dy2 = next.compared - current.compared;

    let x = (current.compared - current.current) / (dy1 - dy2);
    const y = (dy1 * x) + current.current;

    x += i;
    const intersectsInCurrentSection = x > i && x < i + 1;
    if (intersectsInCurrentSection) {
      const intersect = { x: x, current: y, compared: y };
      dataWithIntersects.push(intersect, next);
    } else {
      dataWithIntersects.push(next);
    }
  }
  return dataWithIntersects;
}

export function addAreaRanges(data: Array<ComparedMetricForHour>) {
  const rangedData = [];
  data.forEach((i) => {
    if (i.current > i.compared) {
      rangedData.push({ ...i, currentRange: [i.current, i.compared], comparedRange: [i.compared, i.compared] });
    } else if (i.current < i.compared) {
      rangedData.push({ ...i, currentRange: [i.current, i.current], comparedRange: [i.compared, i.current] });
    } else {
      rangedData.push({ ...i, currentRange: [i.current, i.current], comparedRange: [i.compared, i.compared] });
    }
  });

  return rangedData;
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/domain/AudienceComparisonGraphData.js